import { api } from "@/lib/api";

let toolsPromise = null;
export const resetTools = () => { toolsPromise = null; };
export const loadTools = () => (toolsPromise ||= api.get("/ai/tools").then((r) => r.data).catch(() => { toolsPromise = null; return null; }));

const text = (t) => `${t.id} ${t.title}`.toLowerCase();
export const findAts = (tools = []) =>
  tools.find((t) => /ats/.test(text(t)) && /pass|rate|predict|score/.test(text(t))) || tools.find((t) => /\bats\b|ats[_-]/.test(text(t)));
export const findTailor = (tools = []) =>
  tools.find((t) => /tailor/.test(text(t)) && /resume|cv/.test(text(t))) || tools.find((t) => /tailor/.test(text(t))) ||
  tools.find((t) => /resume|cv/.test(text(t)) && /optimi|rewrite|boost|keyword|custom/.test(text(t)));
